export const pageVariants = {
	hidden: { opacity: 0, y: 14, filter: 'blur(6px)' },
	visible: {
		opacity: 1,
		y: 0,
		filter: 'blur(0px)',
		transition: {
			duration: 0.68,
			ease: [0.22, 1, 0.36, 1] // Custom cubic-bezier for smoother feel
		}
	},
	exit: {
		opacity: 0,
		y: -8,
		filter: 'blur(4px)',
		transition: {
			duration: 0.4,
			ease: 'easeIn'
		}
	}
}

export const containerVariants = {
	hidden: { opacity: 0 },
	visible: {
		opacity: 1,
		transition: {
			staggerChildren: 0.1,
			delayChildren: 0.1
		}
	}
}

export const itemVariants = {
	hidden: { opacity: 0, y: 20 },
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			type: 'spring',
			damping: 25,
			stiffness: 120
		}
	}
}

export const heroVariants = {
	hidden: { opacity: 0, x: -10 },
	visible: {
		opacity: 1,
		x: 0,
		transition: {
			duration: 0.8,
			ease: 'easeOut'
		}
	}
}
